import axiosInstance from './axiosInstance'

export const getProjectChangeOrderById = (id) => {
  return axiosInstance.get(`/project-change-orders/${id}`)
}

export const getProjectChangeOrdersByProjectId = (projectId) => {
  return axiosInstance.get(`/project-change-orders/?projectId=${projectId}`)
}

export const getNegativeChangeOrdersAmountByProjectId = (projectId) => {
  return axiosInstance.get(`/project-change-orders/get-negative-commission-amount-by-project-id?projectId=${projectId}`)
}

// export const getProjectChangeOrders = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
//   return axiosInstance.get(`/project-change-orders?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
// }

export const createProjectChangeOrder = (data) => {
  return axiosInstance.post('/project-change-orders', data)
}

export const updateProjectChangeOrder = (id, data) => {
  return axiosInstance.put(`/project-change-orders/${id}`, data)
}

export const approveProjectChangeOrder = (id, data) => {
  return axiosInstance.post(`/project-change-orders/${id}/approve`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const deleteProjectChangeOrder = (id) => {
  return axiosInstance.delete(`/project-change-orders/${id}`)
}
